import { render, staticRenderFns } from "./CustTableMain.vue?vue&type=template&id=359c3ffe"
import script from "./CustTableMain.vue?vue&type=script&lang=js"
export * from "./CustTableMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports